export const SUPPORT = 'support';
export const SYSTEM_OWNER = 'system_owner';

export const supportLevelOptions = [
    { value: SUPPORT, title: '1-я линия поддержки' },
    { value: SYSTEM_OWNER, title: 'Владелец системы' },
];

export function supportLevelTitle(value) {
    return supportLevelOptions.find((option) => option.value === value)?.title || 'Уровень не указан';
}
